/**
 * @author xiaohuangmaoth
 * @description 线下培训学员统计
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';
import moment from "moment";
const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class StatisticsOfflineTrainees extends WizContainer {
  componentName = "StatisticsOfflineTrainees";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        accountState: val.accountState ? '激活' :'禁用',
        jobState: val.jobState ? '在职' :'离职',
        attendanceState: val.attendanceState!=null && val.attendanceState===1 ? '请假' : val.attendanceState!=null && val.attendanceState===2 ?
          '全勤':val.attendanceState!=null && val.attendanceState===3 ? '缺勤' : '未输入',
        pass: val.pass!=null && val.pass===1 ? '通过' : val.pass!=null && val.pass===2 ?
          '未通过':val.pass!=null && val.pass===3 ? '无成绩' : '未输入',
      }))
      const title = '培训管理学员统计'
      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  handleSimpleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res
    let columnDefs = [
      {
        headerName: '培训管理学员统计',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: 'ASC',
        field: 'orgCode',
        width: 20,
      },
      {
        headerName: '经销商',
        field: 'orgName',
        width: 30,
      },					
      {
        headerName: '学员',
        field: 'fullName',
        width: 20,
      },
      {
        headerName: '培训情况',
        field: 'pass',
        width: 20,
      },
      {
        headerName: '课程名',
        field: 'name',
        width: 20,
      },
      {
        headerName: '数据实际时间',
        field: 'nowTime',
        width: 20,
      },
    ]
    if (success) {
      const rows = data.map(val => ({
        ...val,
        pass: val.pass!=null && val.pass===1 ? '通过' : val.pass!=null && val.pass===2 ?
          '未通过':val.pass!=null && val.pass===3 ? '无成绩' : '未输入',
        nowTime: moment(new Date()).format('YYYY-MM-DD HH:mm')
      }))
      const title = '培训管理学员统计'
      WizBrowserExport({
        title,
        sheetName: title,
        columns: columnDefs.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile,
        list: this._handleCMD,
        simpleExport: this.handleSimpleFile,
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(StatisticsOfflineTrainees);
